import { toast } from '@quinyx/ui';

import i18n from '../../i18n';
import { CONFIG } from '../config';
import { IFormErrorResponse, IErrorResponse } from '../interfaces';

export const buildUrl = (url: string): string => `${CONFIG.API}${url}`;

export const buildFrontlineUrl = (url: string): string =>
  `${CONFIG.FRONTLINE_API}${url}`;

const isApiFormError = (error: any): error is IFormErrorResponse =>
  Array.isArray((error as IFormErrorResponse).response?.data);

const isApiError = (error: any): error is IErrorResponse =>
  (error as IFormErrorResponse).response !== undefined;

export const handleError = (error: any) => {
  if (isApiFormError(error))
    return error.response.data.forEach(({ message }) =>
      toast(message, 'negative'),
    );

  if (isApiError(error)) return toast(error.response.data.message, 'negative');

  return toast(i18n.t('toast.somethingWentWrongTryAgain'), 'negative');
};
